var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "time",
    {
      staticClass: "timer",
      style: _vm.timerStyle,
      attrs: { datetime: _vm.toHumanTime(_vm.time) }
    },
    [
      _vm._v(
        _vm._s("" + (_vm.remaining ? "-" : "") + _vm.toHumanTime(_vm.time))
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }